import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '@/components/card';
import { LeadForm } from './lead-form';
import { useCreateLead } from '@/lib/leads';

export function NewLead() {
  const navigate = useNavigate();
  const create = useCreateLead();

  return (
    <div className="mx-auto max-w-3xl space-y-5">
      <h1 className="text-2xl font-semibold tracking-tight">New lead</h1>
      <Card>
        <CardHeader>
          <p className="text-sm text-[var(--color-foreground-muted)]">
            Capture the inquiry now — refine the stage, value, and notes after you've followed up.
          </p>
        </CardHeader>
        <CardBody>
          <LeadForm
            onSubmit={async (input) => {
              const lead = await create.mutateAsync(input);
              navigate(`/leads/${lead.id}`);
            }}
            submitLabel="Create lead"
          />
        </CardBody>
      </Card>
    </div>
  );
}
